import { Plan2PlateDrawer, Plan2PlateDrawerHeader } from "./Plan2PlateDrawer";
import React, { useMemo } from "react";
import { DishEditor } from "./DishEditor";
import { usePersonsAsync } from "../queries/queries";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateAvailabilities } from "../queries/caches";
import { createByIdLookup } from "../loaders";
import { DishModification, emptyDish } from "../data/dishModification";

interface CreateDishDrawerProps {
  onClose: () => void;
  open: boolean;
  onSubmit: (d: any, isFood?: boolean) => void | Promise<void>;
  initialDish?: DishModification;
}

export function CreateDishDrawer(props: CreateDishDrawerProps) {
  return (
    <Plan2PlateDrawer
      onClose={props.onClose}
      open={props.open}
      header={<Plan2PlateDrawerHeader heading={"Gericht erstellen"} />}
      body={<CreateDishDrawerBody {...props} />}
    />
  );
}

function CreateDishDrawerBody(props: CreateDishDrawerProps) {
  const persons = usePersonsAsync(false);
  const queryClient = useQueryClient();
  const personLookup = useMemo(() => createByIdLookup(persons), [persons]);
  const loadAvailabilities = async () => {
    await invalidateAvailabilities(queryClient);
  };
  return (
    <DishEditor
      initialDish={props.initialDish || emptyDish()}
      isCreate
      loadAvailabilities={loadAvailabilities}
      personLookup={personLookup}
      afterSave={(createdDish: any, isFood: boolean) => {
        props.onClose();
        props.onSubmit(createdDish, isFood);
      }}
    />
  );
}
